export default {"src":"/_next/static/image/public/images/ic_insurance_sheild.7c90c0fbf4af0e16fa13cc89365e5d74.svg","height":34,"width":34};